import React, { useState, useEffect } from 'react';
import {
    Stepper,
    Step,
    StepLabel,
    Button,
    Box,
    styled,
    // CircularProgress,
} from '@mui/material';
import Step1 from './PersonalInformationForm';
import Step2 from './IdentityDetailsForm';
import Step3 from './EnterOTP';

import { toast } from 'react-toastify';

import KYCUpdateMessage from './KYCUpdateMessage';
import axiosVendorInstance from '../../../axiosVendorInstance';
import { useNavigate } from 'react-router-dom';
import KYCVerificationRejected from './KYCVerificationRejected';
import { jwtDecode } from 'jwt-decode';
import Loader from '../../../Components/Loader/Loader';
import axios from 'axios';

const VendorRegistrationForm = () => {
    const token = localStorage.getItem('authToken');
    const decodedToken = jwtDecode(token);
    const [loading, setLoading] = useState(true);
    const [kycFormData, setKycFormData] = useState({
        businessName: '',
        address: '',
        city: '',
        state: '',
        country: 'USA',
        pincode: '',
        email: '',

        legalBusinessName: '',
        taxId: '',
        representativeName: '',
        phoneNumber2: '',
        dob: '',
        routingNumber: '',
        accountNumber: '',
        reEnterAccountNumber: '',
    });
    const [image, setImage] = useState(null);
    const [imageError, setImageError] = useState('');
    const [errors, setErrors] = useState({});
    const [kycStatus, setKycStatus] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const navigate = useNavigate();

    const MAP_BASE_URL = 'https://maps.googleapis.com/maps/api/geocode/json';

    useEffect(() => {
        setKycFormData((prevFormData) => ({
            ...prevFormData,
            email: decodedToken?.email,
        }));
    }, []);


    const steps = ['Personal Information', 'Identity Details', 'KYC Update'];

    const fetchKycStatus = async () => {
        setLoading(true);
        try {
            const response = await axiosVendorInstance.get(
                '/vendors/account', 
            );
            const status = response?.data?.getVendorInfo[0]?.status;
            setKycStatus(status);
        } catch (error) {
            console.log('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchKycStatus();
    }, [decodedToken?.id]);

    const handleNext = async () => {
        if (activeStep === 0) {
            if (!validateStep1()) {
                toast.error('please fill all fields');
            } else {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
            }
        } else if (activeStep === 1) {
            if (!validateStep2()) {
                toast.error('please fill all fields');
            } else {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
            }
        } else if (activeStep === 2) {
            if (validateStep3()) {
                try {
                    const apiKey = process.env.REACT_APP_GOOGLE_MAP_KEY;
                    const fullAddress = `${kycFormData?.address}, ${kycFormData?.city}, ${kycFormData?.state}, ${kycFormData?.country}, ${kycFormData?.pincode}`;
                
                    const geoResponse = await axios.get(
                        MAP_BASE_URL,
                        {
                            params: {
                                address: fullAddress,
                                key: apiKey,
                            },
                        }
                    );

                    if (geoResponse?.data?.status !== 'OK') {
                        toast.error('Failed to get location coordinates');
                        return;
                    }

                    const location = geoResponse?.data?.results[0]?.geometry?.location;
                    const latitude = location?.lat;
                    const longitude = location?.lng;

                    const formData = new FormData();

                    formData.append('Name', kycFormData.businessName);
                    formData.append('Type', 1);
                    formData.append('Location', `${latitude},${longitude}`);
                    formData.append('Address', kycFormData.address);
                    formData.append('City', kycFormData.city);
                    formData.append('State', kycFormData.state);
                    formData.append('Country', kycFormData.country);
                    formData.append('Pincode', kycFormData.pincode);
                    formData.append('Phone_number', kycFormData.phoneNumber2);
                    formData.append('Email', kycFormData.email);
                    formData.append('featureImage', image);
                    formData.append('Legal_Business_Name', kycFormData.legalBusinessName);
                    formData.append('EIN_or_Tax_ID', kycFormData.taxId);
                    formData.append('Representative_Name', kycFormData.representativeName);
                    formData.append('Date_of_birth', kycFormData.dob);
                    formData.append('Routing_Number', kycFormData.routingNumber);
                    formData.append('Account_Number', kycFormData.accountNumber);
                    formData.append('Status', 'Pending');
                    formData.append('Created_at', new Date().toISOString());
                    formData.append('Updated_at', new Date().toISOString());
                    formData.append('Created_by', decodedToken?.id);
                    formData.append('Updated_by', decodedToken?.id);

                    setIsLoading(true);
                    await axiosVendorInstance.post('/vendors/account', formData);
                    setIsLoading(false);

                    toast.success('Data Submitted Successfully');
                    fetchKycStatus();
                } catch (error) {
                    setIsLoading(false);
                    console.error(error);
                    toast.error(error?.response?.data?.error || 'Submission Failed');
                }
            } else {
                toast.error('Please complete all required fields before submitting the form');
            }
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        let tempErrors = { ...errors };

        if (name === 'businessName') {
            if (!/^[a-zA-Z0-9\s]{3,}$/.test(value)) {
                tempErrors[name] = 'Enter Valid BusinessName';
            } else {
                delete tempErrors[name];
            }
        } else if (name === 'address') {
            if (!/^[a-zA-Z0-9\s,:-]{10,}$/.test(value)) {
                tempErrors[name] = 'Enter Valid Address';
            } else {
                delete tempErrors[name];
            }
        }
        if (name === 'city') {
            if (!/^[a-zA-Z\s]{3,}$/.test(value)) {
                tempErrors[name] = 'Enter Valid City';
            } else {
                delete tempErrors[name];
            }
        } else if (name === 'state') {
            if (!/^[a-zA-Z\s]{3,}$/.test(value)) {
                tempErrors[name] = 'Enter Valid State';
            } else {
                delete tempErrors[name];
            }
        } else if (name === 'country') {
            if (!/^[a-zA-Z\s]{3,}$/.test(value)) {
                tempErrors[name] = 'Enter Valid Country';
            } else {
                delete tempErrors[name];
            }
        } else if (name === 'pincode') {
            if (!/^[0-9]{5}$/.test(value)) {
                tempErrors[name] = 'Enter Valid Zipcode';
            } else {
                delete tempErrors[name];
            }
        } else if (name === 'email') {
            if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
                tempErrors[name] = ' Enter Valid Email ';
            } else {
                delete tempErrors[name];
            }
        }

        if (name === 'legalBusinessName') {
            if (!/^[a-zA-Z0-9\s]{3,}$/.test(value)) {
                tempErrors[name] = 'Enter Valid Legal Business name ';
            } else {
                delete tempErrors[name];
            }
        } else if (name === 'taxId') {
            if (!/^\d{2}-\d{7}$/.test(value)) {
                tempErrors[name] = 'Enter Valid EIN/Tax Id ';
            } else {
                delete tempErrors[name];
            }
        } else if (name === 'representativeName') {
            if (!/^[a-zA-Z\s]{3,}$/.test(value)) {
                tempErrors[name] = ' Enter Valid Representative Name ';
            } else {
                delete tempErrors[name];
            }
        } else if (name === 'dob') {
            if (!value) {
                tempErrors[name] = 'Date of Birth is required';
            } else {
                delete tempErrors[name];
            }
        }

        if (name === 'routingNumber') {
            if (!/^\d{9}$/.test(value)) {
                tempErrors[name] = 'Enter Valid Routing Number ';
            } else {
                delete tempErrors[name];
            }
        } else if (name === 'accountNumber') {
            if (!/^\d{8,17}$/.test(value)) {
                tempErrors[name] = 'Enter Valid Account Number ';
            } else {
                delete tempErrors[name];
            }
        } else if (name === 'reEnterAccountNumber') {
            if (value !== kycFormData.accountNumber) {
                tempErrors[name] = 'Account numbers do not match.';
            } else if (!/^\d{8,17}$/.test(value)) {
                tempErrors[name] = 'Re-enter account number is required.';
            } else {
                delete tempErrors[name];
            }
        }

        setKycFormData({
            ...kycFormData,
            [name]: value,
        });

        setErrors(tempErrors);
    };

    const handlePhoneChange2 = (value) => {
        let tempErrors = { ...errors };

        if (!/^\d{10}$/.test(value)) {
            tempErrors['phoneNumber2'] = 'Phone number is invalid';
        } else {
            delete tempErrors['phoneNumber2'];
        }

        setKycFormData({
            ...kycFormData,
            phoneNumber2: value,
        });

        setErrors(tempErrors);
    };

    const validateAge = (dob) => {
        const birthDate = new Date(dob);
        const today = new Date();

        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        const dayDiff = today.getDate() - birthDate.getDate();

        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--;
        }

        return age >= 18;
    };

    const handleDOBChange = (e) => {
        let tempErrors = { ...errors };
        const value = e.target.value;

        if (validateAge(value)) {
            delete tempErrors['dob'];
        } else {
            tempErrors['dob'] = 'You must be at least 18 years old.';
        }

        setKycFormData({
            ...kycFormData,
            dob: value,
        });

        setErrors(tempErrors);
    };

    const handleEINChange = (e) => {
        let tempErrors = { ...errors };
        let value = e.target.value;

        value = value.replace(/\D/g, '');

        if (value.length > 2) {
            value = value.substring(0, 2) + '-' + value.substring(2, 9);
        }

        if (!/^\d{2}-\d{7}$/.test(value)) {
            tempErrors['taxId'] = 'Please use the format: XX-XXXXXXX.';
        } else {
            delete tempErrors['taxId'];
        }

        setKycFormData({
            ...kycFormData,
            taxId: value,
        });

        setErrors(tempErrors);
    };

    const validateRoutingNumber = (routingNumber) => {
        if (!/^\d{9}$/.test(routingNumber)) return false;

        const digits = routingNumber.split('').map(Number);
        const checksum =
      3 * (digits[0] + digits[3] + digits[6]) +
      7 * (digits[1] + digits[4] + digits[7]) +
      1 * (digits[2] + digits[5] + digits[8]);
        return checksum % 10 === 0;
    };

    const handleRoutingChange = (e) => {
        let value = e.target.value.replace(/\D/g, ''); 
        let tempErrors = { ...errors };

        if (value.length === 9) {
            if (validateRoutingNumber(value)) {
                delete tempErrors['routingNumber'];
            } else {
                tempErrors['routingNumber'] = 'Invalid routing number.';
            }
        } else {
            tempErrors['routingNumber'] = 'Routing number must be exactly 9 digits.';
        }

        setKycFormData({
            ...kycFormData,
            routingNumber: value,
        });

        setErrors(tempErrors);
    };


    function validateAccountNumber(accountNumber) {
        const errors = [];
        if (!accountNumber) {
            errors.push('Account number is required.');
        } else {
            if (!/^\d+$/.test(accountNumber)) {
                errors.push('Account number must contain only digits.');
            }
            if (accountNumber.length < 8 || accountNumber.length > 16) {
                errors.push('Account number must be between 8 and 16 digits.');
            }
            if (/^(.)\1+$/.test(accountNumber)) {
                errors.push('Account number cannot be all the same digit.');
            }
        // Add uniqueness and checksum logic in backend
        }
        return errors;
    }


    const validateStep1 = () => {
        let tempErrors = {};
        let isValid = true;

        if (!kycFormData.businessName) {
            isValid = false;
            tempErrors['businessName'] = 'Business name is required';
        } else if (!/^[a-zA-Z0-9\s]{3,}$/.test(kycFormData.businessName)) {
            isValid = false;
            tempErrors['businessName'] = 'BusinessName is invalid';
        }

        if (!kycFormData.address) {
            isValid = false;
            tempErrors['address'] = 'Address is required';
        } else if (!/^[a-zA-Z0-9\s,:-]{10,}$/.test(kycFormData.address)) {
            isValid = false;
            tempErrors['address'] = 'Address is invalid';
        }

        if (!kycFormData.city) {
            isValid = false;
            tempErrors['city'] = 'City is required';
        } else if (!/^[a-zA-Z\s]{3,}$/.test(kycFormData.city)) {
            isValid = false;
            tempErrors['city'] = 'City is Invalid';
        }

        if (!kycFormData.state) {
            isValid = false;
            tempErrors['state'] = 'State is required';
        } else if (!/^[a-zA-Z\s]{3,}$/.test(kycFormData.state)) {
            isValid = false;
            tempErrors['state'] = 'State is Invalid';
        }

        // if (!kycFormData.country) {
        //     isValid = false;
        //     tempErrors['country'] = 'country is required';
        // } else if (!/^[a-zA-Z\s]{3,}$/.test(kycFormData.country)) {
        //     isValid = false;
        //     tempErrors['country'] = 'country is invalid';
        // }

        if (!kycFormData.pincode) {
            isValid = false;
            tempErrors['pincode'] = 'Zipcode is required';
        } else if (!/^\d{5}$/.test(kycFormData.pincode)) {
            isValid = false;
            tempErrors['pincode'] = 'Zipcode is invalid';
        }

        if (!kycFormData.email) {
            isValid = false;
            tempErrors['email'] = 'Email is required';
        } else if (
            !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(kycFormData.email)
        ) {
            isValid = false;
            tempErrors['email'] = 'Email is invalid';
        }

        if (!image) {
            isValid = false;
            setImageError('Feature image is required');
        } else {
            setImageError('');
        }

        setErrors(tempErrors);
        return isValid;
    };

    const validateStep2 = () => {
        let tempErrors = {};
        let isValid = true;

        if (!kycFormData.legalBusinessName) {
            isValid = false;
            tempErrors['legalBusinessName'] = 'Legal Business name is required';
        } else if (!/^[a-zA-Z0-9\s]{3,}$/.test(kycFormData.legalBusinessName)) {
            isValid = false;
            tempErrors['legalBusinessName'] = 'Legal Business Name is invalid';
        }

        if (!kycFormData.taxId) {
            isValid = false;
            tempErrors['taxId'] = 'EIN/Tax Id is required';
        } else if (!/^\d{2}-\d{7}$/.test(kycFormData.taxId)) {
            isValid = false;
            tempErrors['taxId'] = 'EIN/Tax Id is invalid';
        }

        if (!kycFormData.representativeName) {
            isValid = false;
            tempErrors['representativeName'] = 'Representative name is required';
        } else if (!/^[a-zA-Z\s]{3,}$/.test(kycFormData.representativeName)) {
            isValid = false;
            tempErrors['representativeName'] = 'Representative Name is invalid';
        }

        if (!kycFormData.phoneNumber2) {
            isValid = false;
            tempErrors['phoneNumber2'] = 'Phone number is required';
        } else if (!/^\d{10}$/.test(kycFormData.phoneNumber2)) {
            isValid = false;
            tempErrors['phoneNumber2'] = 'Phone number is invalid';
        }

        if (!kycFormData.dob) {
            isValid = false;
            tempErrors['dob'] = 'Date of birth is required';
        } else if (!kycFormData.dob || !validateAge(kycFormData.dob)) {
            isValid = false;
            tempErrors['dob'] = 'You must be at least 18 years old.';
        }

        setErrors(tempErrors);
        return isValid;
    };

    const validateStep3 = () => {
        let tempErrors = {};
        let isValid = true;

        if (!kycFormData.routingNumber) {
            isValid = false;
            tempErrors['routingNumber'] = 'Routing number is required';
        } else if (
            !/^\d{9}$/.test(kycFormData.routingNumber) ||
            !validateRoutingNumber(kycFormData.routingNumber)
        ) {
            isValid = false;
            tempErrors['routingNumber'] = 'Routing number is invalid';
        }

        const accountErrors = validateAccountNumber(kycFormData.accountNumber);
        if (accountErrors.length > 0) {
            isValid = false;
            tempErrors['accountNumber'] = accountErrors.join(' ');
        }

        if (!kycFormData.reEnterAccountNumber) {
            isValid = false;
            tempErrors['reEnterAccountNumber'] = 'Re-enter account number is required';
        } else if (kycFormData.reEnterAccountNumber !== kycFormData.accountNumber) {
            isValid = false;
            tempErrors['reEnterAccountNumber'] = 'Re-entered account number does not match';
        }

        setErrors(tempErrors);
        return isValid;
    };

    const CustomButton = styled(Button)({
        backgroundColor: '#E13535',
        color: '#FFFFFF',
        marginTop: '30px',
        marginBottom: '30px',
        '&:hover': {
            backgroundColor: '#E13535',
            color: '#FFFFFF',
        },
    });

    const BackButton = styled(Button)({
        border: '1px solid var(--Neutral-n200, #E2E8F0)',
        marginTop: '30px',
        marginBottom: '30px',
    });

    const CustomStepIcon = (props) => {
        const { active, completed, icon } = props;

        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: 20,
                    height: 20,
                    borderRadius: '50%',
                    backgroundColor: active || completed ? '#02A750' : '#F2F4F7',
                    color: active || completed ? '#FFFFFF' : '#2C3142',
                }}
            >
                {icon}
            </Box>
        );
    };

    return (
        <div className="vendor-registration-form">
            {isLoading && <Loader />}
            <Box className="stepper-container">
                {/* <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '200px',
                        }}
                    >
                        <CircularProgress />
                    </Box> */}
                {loading ? (
                    <Loader />
                ) : (
                    <>
                        {kycStatus === 'pending' || kycStatus === 'rejected' ? (
                            <Stepper activeStep={2} alternativeLabel>
                                {steps.map((label, index) => (
                                    <Step key={index}>
                                        <StepLabel
                                            StepIconComponent={(props) => (
                                                <CustomStepIcon {...props} icon={index + 1} />
                                            )}
                                        >
                                            {label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        ) : (
                            <Stepper activeStep={activeStep} alternativeLabel>
                                {steps.map((label, index) => (
                                    <Step key={index}>
                                        <StepLabel
                                            StepIconComponent={(props) => (
                                                <CustomStepIcon {...props} icon={index + 1} />
                                            )}
                                        >
                                            {label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        )}
                        <Box sx={{ mt: 2, mb: 1 }}>
                            {kycStatus === 'pending' ? (
                                <KYCUpdateMessage />
                            ) : kycStatus === 'approved' ? (
                                navigate('/home')
                            ) : kycStatus === 'rejected' ? (
                                <KYCVerificationRejected />
                            ) : (
                                <Box>
                                    {activeStep === 0 && (
                                        <Step1
                                            formData={kycFormData}
                                            handleChange={handleChange}
                                            errors={errors}
                                            setErrors={setErrors}
                                            setImage={setImage}
                                            imageError={imageError}
                                            setImageError={setImageError}
                                        />
                                    )}
                                    {activeStep === 1 && (
                                        <Step2
                                            formData={kycFormData}
                                            handleChange={handleChange}
                                            handlePhoneChange2={handlePhoneChange2}
                                            errors={errors}
                                            handleEINChange={handleEINChange}
                                            handleDOBChange={handleDOBChange}
                                        />
                                    )}
                                    {activeStep === 2 && (
                                        <Step3
                                            formData={kycFormData}
                                            handleChange={handleChange}
                                            errors={errors}
                                            handleRoutingChange={handleRoutingChange}
                                        />
                                    )}
                                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                        <BackButton
                                            color="inherit"
                                            disabled={activeStep === 0}
                                            onClick={handleBack}
                                            sx={{ mr: 1 }}
                                        >
                      Back
                                        </BackButton>
                                        <Box sx={{ flex: '1 1 auto' }} />
                                        <CustomButton onClick={handleNext}>
                                            {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
                                        </CustomButton>
                                    </Box>
                                </Box>
                            )}
                        </Box>
                    </>
                )}
            </Box>
        </div>
    );
};

export default VendorRegistrationForm;
